'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.currentThreadHistory = undefined;

var _getCurrentConversation = require('../../selectors/conversationSelectors/getCurrentConversation');

var _historyDataForThread = require('./historyDataForThread');

var currentThreadHistory = exports.currentThreadHistory = function currentThreadHistory(state) {
  var thread = (0, _getCurrentConversation.getCurrentConversation)(state);

  return (0, _historyDataForThread.historyDataForThread)(state, { thread: thread });
};


//////////////////
// WEBPACK FOOTER
// ./js/thread-histories/selectors/currentThreadHistory.js
// module id = 623
// module chunks = 2 3